import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface CreateSingleLocationInput {
    address: string;
    city: string;
    state: string;
    zip: string;
    phoneNumber?: string;
    title?: string;
}

interface CreateSingleLocationResponse {
    locationId: string;
}

export const useCreateSingleLocation = () => {
    const sessionContext = useContext(SessionContext);

    const createSingleLocation = async (input: CreateSingleLocationInput): Promise<AxiosResponse<CreateSingleLocationResponse>> => {
        return axios.post(`${API_URL}/settings/location/add`, input, {
            headers: {
                Authorization: sessionContext?.sessionId ?? ''
            }
        });
    };

    return useMutation({
        mutationFn: createSingleLocation,
    });
};
